module.exports = "pegasus/assets/blocks/column-8-theme5.png";